import { css } from 'linaria';

export const counterWrapper = css`
  display: flex;
`;

export const toBasket = css`
  min-width: var(--space-600);
  margin-left: var(--space-150);
`;
